import { render, staticRenderFns } from "./OnboardingModal.vue?vue&type=template&id=065b7a8a&"
import script from "./OnboardingModal.vue?vue&type=script&lang=js&"
export * from "./OnboardingModal.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports